module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Homepod-302ba903cfc78b0972689262b2c8bd90.svg";